import { createFileRoute, redirect } from "@tanstack/react-router";
// 必须直连具体模块：路由壳被 routeTree 静态引用，若此处经 barrel
// （@client/components/doc-center）导入，整个 doc-center 组件树会被
// 静态拖进入口 chunk，登录页连带下载编辑器、图标库等重型依赖。
import { DocCenterPage } from "@client/components/doc-center/doc-center-page";
import { extractSearchParams } from "@client/components/doc-center/doc-center-search";

export const Route = createFileRoute("/_app/doc-center")({
  // 列表页只服务「带目录的 URL」。仅 fileId 的深链走独立预览页，
  // 避免在列表页用详情回填 packId（会与树选中互相顶成请求风暴）。
  beforeLoad: ({ search }) => {
    const s = extractSearchParams(search);
    if (s.fileId && !s.priPackId && !s.pubPackId) {
      // 保留定位参数（page/bbox/blockId），提案证据「第 N 页」深链经此跳预览
      throw redirect({
        to: "/file-preview/$fileId",
        params: { fileId: s.fileId },
        search: {
          ...(s.page ? { page: s.page } : {}),
          ...(s.bbox ? { bbox: s.bbox } : {}),
          ...(s.blockId ? { blockId: s.blockId } : {}),
          ...(s.citationId ? { citationId: s.citationId } : {}),
        },
      });
    }
  },
  component: DocCenterPageRoute,
});

function DocCenterPageRoute() {
  return <DocCenterPage />;
}
